// extracted by mini-css-extract-plugin
module.exports = {"sticky-social-share":"_1v_vB","handle-icon":"_1-fnZ","closed":"_2IjEr","open":"_3Lcg0","social-share":"_1CyWE","social-share-icon":"__mNx"};